module.exports = __webpack_public_path__ + "static/images/skinbtn1.ca1c316.png";